// extracted by mini-css-extract-plugin
export var container = "_9j-0";
export var containerTopRight = "_9j-1";